import styled, { keyframes } from "styled-components";

const theme = {
  bg: "#121212",
  surface: "#1E1E1E",
  surfaceHover: "#2A2A2A",
  gold: "#D4AF37",
  goldHover: "#EACD65",
  text: "#FFFFFF",
  textSecondary: "#A9A9A9",
  border: "#333333",
};

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 2rem 3rem;
  background-image: url("textura.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  box-sizing: border-box;
  animation: ${fadeIn} 0.5s ease-out;

  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;

export const Header = styled.header`
  text-align: center;
  margin-bottom: 2rem;
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  color: black;
  margin: 0 0 0.5rem 0;
`;

export const Subtitle = styled.p`
  font-size: 1.1rem;
  color: rgba(80, 80, 80, 1);
  margin: 0;
`;

export const MainCard = styled.div`
  background-color: ${theme.surface};
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  border: 1px solid ${theme.border};
  max-width: 900px;
  margin: 0 auto 2rem auto;
`;

export const VipBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  padding: 2rem;
  background: rgba(212, 175, 55, 0.08);
  border-radius: 12px;
  border: 1px solid ${theme.gold};
  margin-bottom: 2rem;
  animation: ${fadeIn} 0.5s ease-out;

  .vip-icon {
    font-size: 2.5rem;
    color: ${theme.gold};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .vip-info {
    h3 {
      margin: 0 0 0.5rem 0;
      color: ${theme.gold};
      font-size: 1.2rem;
      text-transform: uppercase;
      letter-spacing: 1px;
    }
    p {
      margin: 0;
      color: ${theme.text};
      font-size: 0.9rem;
      line-height: 1.5;
      strong {
        color: ${theme.gold};
      }
    }
    small {
      display: flex;
      align-items: center;
      gap: 5px;
      margin-top: 10px;
      color: ${theme.textSecondary};
      font-weight: 600;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
    padding: 1.5rem;

    .vip-icon {
      font-size: 2.5rem;
    }
    .vip-info small {
      justify-content: center;
    }
  }
`;

export const Step = styled.div`
  margin-bottom: 2.5rem;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const StepHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

export const StepNumber = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${theme.gold};
  color: ${theme.surface};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 700;
  flex-shrink: 0;
`;

export const StepTitle = styled.h2`
  font-size: 1.5rem;
  color: ${theme.text};
  margin: 0;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

export const QuantityButton = styled.button`
  width: 50px;
  height: 50px;
  background-color: ${theme.border};
  color: ${theme.text};
  border: none;
  border-radius: 8px;
  font-size: 1.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    background-color: ${theme.gold};
    color: ${theme.surface};
  }
`;

export const QuantityInput = styled.input`
  width: 150px;
  height: 70px;
  background-color: ${theme.bg};
  border: 1px solid ${theme.border};
  border-radius: 8px;
  color: ${theme.text};
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const PresetButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
`;

export const PresetButton = styled.button`
  background-color: ${theme.surfaceHover};
  color: ${theme.textSecondary};
  border: 1px solid ${theme.border};
  border-radius: 8px;
  padding: 0.5rem 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    background-color: ${theme.gold};
    color: ${theme.surface};
  }
`;

export const TotalCost = styled.div`
  text-align: center;
  font-size: 1.2rem;
  color: ${theme.textSecondary};
  span {
    color: ${theme.text};
    font-weight: 700;
    font-size: 1.5rem;
  }
`;

export const ActionButton = styled.button`
  width: 100%;
  padding: 1rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 12px;
  cursor: pointer;
  border: none;
  background: ${theme.gold};
  color: ${theme.surface};
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  &:hover {
    background: ${theme.goldHover};
    transform: translateY(-3px);
    box-shadow: 0 10px 20px -5px rgba(212, 175, 55, 0.3);
  }
`;

export const SimulationResult = styled.div`
  animation: ${fadeIn} 0.5s ease-out;
`;

export const ResultGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ResultCard = styled.div`
  background-color: ${theme.bg};
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
  border: 1px solid ${theme.border};
`;

export const ResultLabel = styled.p`
  margin: 0 0 0.5rem 0;
  font-size: 0.9rem;
  color: ${theme.textSecondary};
  text-transform: uppercase;
`;

export const ResultValue = styled.span`
  font-size: 1.75rem;
  font-weight: 700;
  color: ${theme.gold};
`;

export const TabelaContainer = styled.div`
  border-radius: 16px;
  box-sizing: border-box;
  padding: 30px;
`;

export const TabelaHeader = styled.div`
  border-bottom: 1px solid ${theme.border};
  h2 {
    font-size: 1.5rem;
    color: black;
    margin: 0;
  }
`;

export const SecondaryActionButton = styled.button`
  width: 100%;
  padding: 1rem;
  margin-top: 1rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 12px;
  cursor: pointer;
  background: transparent;
  color: ${theme.gold};
  border: 2px solid ${theme.gold};
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;

  &:hover {
    background: ${theme.gold};
    color: ${theme.surface};
  }
`;

export const PlansContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 2rem;
  padding: 1.2rem;
  background: rgba(212, 175, 55, 0.05);
  border-radius: 12px;
  border: 1px dashed ${theme.gold};
`;

export const PlanTier = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem 1rem;
  border-right: 1px solid ${theme.border};

  &:last-child {
    border-right: none;
  }

  @media (max-width: 768px) {
    border-right: none;
    border-bottom: 1px solid ${theme.border};
    width: 100%;
    padding: 1rem 0;
  }
`;

export const TierLabel = styled.span`
  font-size: 0.85rem;
  color: ${theme.textSecondary};
  text-transform: uppercase;
  margin-bottom: 0.25rem;
`;

export const TierValue = styled.span`
  font-size: 1.1rem;
  color: ${theme.gold};
  font-weight: 700;
`;
